module.exports = __webpack_public_path__ + "img/documents.d513bce8.svg";